import { useMemo } from 'react';
import { StyleSheet } from '@react-pdf/renderer';

export const useStyles = () => {
  return useMemo(
    () =>
      StyleSheet.create({
        root: {
          paddingVertical: 10,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignContent: 'center',
        },
        title: { fontSize: 9, fontWeight: 'normal' },
        value: { fontSize: 10, fontWeight: 'bold' },
      }),
    [],
  );
};
